<template>
  <div
    :key="`attachment-${attachment.id}`"
    :class="`${mode}-attachment-block flex pt-3 pb-2 pr-4 pl-5`">
    <div
      class="flex"
      style="max-width: calc(100% - 32px);">
      <sIcon
        :class="`${mode}-attachment-icon`"
        size="14"
        type="draft"/>
      <div>
        <p :class="`${mode}-attachment-title`">
          {{ attachment.fileName }}
        </p>
      </div>
    </div>
    <sPopover
      ref="popover"
      placement="bottom-end"
      trigger="click">
      <sButton
        slot="reference"
        icon="menu"
        small
        type="text"/>
      <div :class="`${mode}-attachment-menu`">
        <div :class="`${mode}-attachment-menu-item`">
          <sButton
            v-if="false"
            icon="eye"
            small
            type="text"
            @click="showDocument(attachment)">
            {{ $t('Common.ViewFile') }}
          </sButton>
        </div>
        <div :class="`${mode}-attachment-menu-item`">
          <sButton
            icon="download"
            small
            type="text"
            @click="downloadDocument(attachment)">
            {{ $t('Tenders.Download') }}
          </sButton>
        </div>
      </div>
    </sPopover>
  </div>
</template>
<script>
import { innerChatMixin } from 'mixins'

/**
 * Документы вопросов к внутреннему чату
 */
export default {
  name: 'innerChatAttachments',
  mixins: [innerChatMixin],
  methods: {
    showDocument(attachment) {
      this.$refs.popover.showPopper = false
      this.$root.$emit('showDocumentView', attachment)
    },
    downloadDocument(attachment) {
      this.$_innderChatDownloadFiles(attachment.id, attachment.fileName)
      this.$refs.popover.showPopper = false
    },
  },
  props: {
    /**
     * Документ
     */
    attachment: {
      type: Object
    },
    mode: {
      type: String,
      validator: function (value) {
        return ['left', 'right'].indexOf(value) !== -1
      },
      default: 'left'
    }
  }
}
</script>
<style scoped lang="scss">
.right-attachment,
.left-attachment {
  &-block {
    border-radius: 8px;
    margin-top: 12px;
    max-width: 410px;
    display: flex;
    justify-content: space-between;
  }
  &-icon {
    margin: 4px 10px auto 0;
  }
  &-title {
    font-size: 14px;
    margin-bottom: 0;
    max-width: 280px;
    overflow: auto;
  }
  &-menu {
    padding: 9px 15px;
  }
  &-menu-item {
    padding: 3px 0;
  }
}
.left-attachment {
  &-block {
    background: var(--green_chosen_light);
  }
}
.right-attachment {
  &-block {
    background: var(--color-main-green);
    margin-right: 0;
    margin-left: auto;
  }
}
</style>
